var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgScribble(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 49,
    height: 49,
    viewBox: "0 0 49 49",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M34.1398 37.9482C34.2115 38.3685 34.5533 38.5246 34.7443 38.7935C34.8556 38.9499 34.9973 39.2545 34.877 39.2858C34.0235 39.5072 33.8085 40.7414 32.7544 40.6047C28.4763 40.0514 24.1955 40.7901 19.9167 40.5789C19.6156 40.5642 19.3142 40.5692 19.0132 40.5575C17.2746 40.4919 17.2746 40.4913 17.7145 38.884C18.167 37.23 18.266 37.1234 20.067 36.9246C23.8086 36.5113 27.5531 36.1186 31.3134 35.9185C32.4861 35.8558 33.6612 35.9097 34.6681 36.6425C34.9379 36.8385 35.198 37.0687 35.3995 37.3311C35.5761 37.5616 35.7659 37.8885 35.5362 38.1579C35.2975 38.4376 35.0714 38.1272 34.8532 38.0162C34.6535 37.9148 34.4575 37.7968 34.1398 37.9482Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M32.6185 20.2978C31.5108 21.2725 30.1448 21.6808 28.7504 22.0255C25.7219 22.7735 22.5945 23.0318 19.584 23.8727C19.002 24.0353 18.8128 23.839 18.8351 23.1789C18.9004 21.2608 20.2831 20.7169 21.744 20.3121C24.6766 19.4999 27.6318 18.7707 30.5733 17.9919C31.3357 17.7901 32.0851 17.5391 32.8358 17.2951C33.2699 17.1545 33.5619 17.3593 33.8181 17.6583C34.0832 17.9679 33.9751 18.2218 33.7742 18.5592C33.4172 19.1593 33.1442 19.8084 32.6185 20.2978Z",
    fill: "black"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.6638 4.1285C19.7545 3.0378 20.8399 1.94241 21.9383 0.859907C22.288 0.515475 22.6573 0.151419 23.2149 0.492337C23.724 0.803966 23.386 1.20756 23.352 1.593C23.2867 2.33663 22.9701 2.96662 22.5439 3.548C20.6914 6.07823 18.6433 8.41633 16.0114 10.183C15.7265 10.3737 15.4802 10.6317 15.107 10.4712C14.6853 10.2902 14.8976 9.91384 14.8381 9.60368C14.5599 8.15624 15.4189 7.29663 16.3412 6.42998C17.1349 5.68371 17.8874 4.89322 18.6579 4.12264L18.6638 4.1285Z",
    fill: "black"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgScribble);
export default __webpack_public_path__ + "static/media/scribble.cde84228961dc945397c8f7ad71b38b9.svg";
export { ForwardRef as ReactComponent };